/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import DropDown from 'app/components/common/DropDown.jsx';
import FeedConfigurePanel from 'app/components/EditorComponents/FeedConfigurePanel.jsx';
import TwitterInputConfigPanel from 'app/components/EditorComponents/TwitterInputConfigPanel.jsx';
import InstagramConfigPanel from 'app/components/EditorComponents/InstagramConfigPanel.jsx';
import FacebookPageConfigPanel from 'app/components/EditorComponents/FacebookPageConfigPanel.jsx';
import InputEditorButtons from 'app/mixins/InputEditorButtonsMixin.js';
import ButtonList from 'app/components/common/ButtonList.jsx';
import EchoComponent from 'app/components/EditorComponents/EchoComponent.jsx';
import * as _ from 'underscore';
import { Outlet } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class CreateFeedConfigure extends React.Component {
    render() {
        // there should only be a single input - this configure shown for
        // simple route view
        let constants = this.props.app.config.constants,
            Config = '',
            buttons = null,
            {children, ...otherProps} = this.props,
            validationErrors = null,
            validationErrorDisplay = null;

        validationErrors = this.props.getApiErrors(['INPUT_VALIDATE']);
        if (validationErrors.length) {
            let error = validationErrors[0],
                errorMsg = '';

            if (error.errors.perms !== undefined) {
                errorMsg = error.errors.perms.msg;
            } else if (error.errors.validation) {
                errorMsg = "Sorry, we're unable to validate this input configuration.";
            }
            validationErrorDisplay = (
                <div className="detail-status error">
                    {errorMsg}
                </div>
            );
        }

        if (this.props.router.location.pathname.match(/new\/configure$/)) {
            switch (parseInt(this.props.input.type, 10)) {
                case constants.INPUT_TYPE_FEED:
                    Config = (
                        <FeedConfigurePanel
                            {...this.props}
                            input={this.props.input}
                    		textRuleHandler={this.props.textRuleHandler}
                    		scheduleHandler={this.props.scheduleHandler}
                            context="onboarding"
                            statePath={this.props.statePath} />
                    );
                    break;

                case constants.INPUT_TYPE_TWITTER:
                    // don't show twitter fields since we got the account/list/favorites data
                    // in a prior step
                    Config = (
                        <TwitterInputConfigPanel
                                {...this.props}
                                input={this.props.input}
                                textRuleHandler={this.props.textRuleHandler}
                                scheduleHandler={this.props.scheduleHandler}
                                statePath={this.props.statePath}
                                showTwitterFields={false} />
                    );
                    break;

                case constants.INPUT_TYPE_INSTAGRAM:
                case constants.INPUT_TYPE_INSTAGRAM_BUSINESS:
                    let replay = (
                        <EchoComponent {...this.props}/>
                    );
                    Config = (
                        <InstagramConfigPanel
                            {...this.props}
                            input={this.props.input}
                            textRuleHandler={this.props.textRuleHandler}
                            scheduleHandler={this.props.scheduleHandler}
                            statePath={this.props.statePath}
                            replayPromo={replay} />
                    )
                    break;

                case constants.INPUT_TYPE_FACEBOOK_PAGE:
                    Config = (
                        <FacebookPageConfigPanel
                            {...this.props}
                            input={this.props.input}
                            textRuleHandler={this.props.textRuleHandler}
                            scheduleHandler={this.props.scheduleHandler}
                            statePath={this.props.statePath} />
                    );
                    break;

                default:
                    break;
            }
        } else {
            buttons = InputEditorButtons.getButtons.apply(this, ['/share/automate/new/configure/input']);
            Config = (
                <div>
                    <ButtonList
                        buttons={buttons}
						wrapperClass="editor-tabs"
						linkClass="editor-tab-item"
						activeClass="tab-active"
						errorClass="tab-error" />
                    <Outlet context={otherProps}/>
                </div>
            );
        }

        return (
            <div>
                {validationErrorDisplay}
                {Config}
            </div>
        );

    }

};

CreateFeedConfigure.displayName = "CreateFeedConfigure";

CreateFeedConfigure.propTypes = {
    input: PropTypes.object,
    changeHandler: PropTypes.func,
    textRuleHandler: PropTypes.func,
    scheduleHandler: PropTypes.func,
    statePath: PropTypes.string,
};

CreateFeedConfigure.defaultProps = {
    input: {},
    changeHandler: () => {},
    textRuleHandler: () => {},
    scheduleHandler: () => {},
    statePath: 'input',
};

export default ComponentWithContext(CreateFeedConfigure);
